import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '../common/Icons';

const NAV_ITEMS = [
  { label: 'Home',       icon: 'home',     path: '/' },
  { label: 'Categories', icon: 'category', path: '/categories' },
  { label: 'Cleanup',    icon: 'sparkles', path: '/cleanup' },
  { label: 'Summary',    icon: 'summary',  path: '/summary' },
  { label: 'Trash',      icon: 'trash',    path: '/trash' },
  { label: 'Settings',   icon: 'settings', path: '/settings' },
];

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (path) => {
    if (path === '/categories' || path === '/folders') {
      window.dispatchEvent(new CustomEvent('memora:reset-categories-view'));
      window.dispatchEvent(new CustomEvent('memora:reset-folders-view'));
    }
    navigate(path);
    if (window.innerWidth < 992) {
      onClose?.();
    }
  };

  return (
    <>
      {/* Backdrop overlay when sidebar is open (mobile only) */}
      <div
        className={`sidebar-drawer-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside className={`sidebar-drawer ${isOpen ? 'open' : ''}`} aria-label="Main Navigation">
        <nav className="sidebar-drawer-nav">

          {NAV_ITEMS.map(item => {
            const isActive = pathname === item.path || (item.path === '/categories' && pathname === '/folders');
            return (
              <button
                key={item.path}
                type="button"
                className={`drawer-nav-item ${isActive ? 'active' : ''}`}
                onClick={() => go(item.path)}
              >
                <div className="drawer-item-icon">
                  <Icon name={item.icon} size={18} />
                </div>
                <div className="drawer-item-text">
                  <span className="drawer-item-label">{item.label}</span>
                </div>
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
}
